/**
 * Next.js client instrumentation entrypoint.
 *
 * This early entry intentionally imports only the tiny local buffer. Analytics
 * delivery stays owned by the hydrated application providers.
 */

import {
  installEarlyClientErrorCapture,
  recordRouterTransitionStart,
  type ClientNavigationType,
} from "./lib/client-instrumentation-buffer";

installEarlyClientErrorCapture();

export function onRouterTransitionStart(
  url: string,
  navigationType: ClientNavigationType,
): void {
  recordRouterTransitionStart(url, navigationType);
}
